var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup73477(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.871,
    height: 89.646,
    viewBox: "0 0 87.871 89.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73477",
    "data-name": "Group 73477",
    transform: "translate(-152 -281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65150",
    "data-name": "Group 65150",
    transform: "translate(56 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No_Channel_Search_Found",
    "data-name": "No Channel Search Found",
    transform: "translate(96 292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_15",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55482_00000029014919791660216660000001497220834452269735_",
    d: "M89.526,51.355c.919,18.735-18.461,28.857-35.366,34.511-16.343,5.466-35.966,7.408-46-7.3C-1.8,63.956,5.17,44.024,16.368,30.45c8.5-10.308,22.389-7.669,34.873-4.1,16.007,4.574,37.425,7.487,38.284,25.007",
    transform: "translate(-1.687 -11.59)",
    fill: "#f2f1ef"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3393",
    "data-name": "Ellipse 3393",
    cx: 1.376,
    cy: 1.361,
    rx: 1.376,
    ry: 1.361,
    transform: "translate(71.753 13.195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3394",
    "data-name": "Ellipse 3394",
    cx: 1.376,
    cy: 1.361,
    rx: 1.376,
    ry: 1.361,
    transform: "translate(67.628 13.195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3395",
    "data-name": "Ellipse 3395",
    cx: 1.467,
    cy: 1.451,
    rx: 1.467,
    ry: 1.451,
    transform: "translate(81.888)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3396",
    "data-name": "Ellipse 3396",
    cx: 0.734,
    cy: 0.725,
    rx: 0.734,
    ry: 0.725,
    transform: "translate(83.726 9.258)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2739",
    "data-name": "Line 2739",
    d: "M1.732,0H0V-.511H1.732Z",
    transform: "translate(0 4.551)",
    fill: "#c2c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2740",
    "data-name": "Line 2740",
    d: "M0,1.713H-.511V0H0Z",
    transform: "translate(1.122 3.44)",
    fill: "#c2c1c0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3397",
    "data-name": "Ellipse 3397",
    cx: 0.734,
    cy: 0.725,
    rx: 0.734,
    ry: 0.725,
    transform: "translate(9.721 6.718)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3398",
    "data-name": "Ellipse 3398",
    cx: 0.734,
    cy: 0.725,
    rx: 0.734,
    ry: 0.725,
    transform: "translate(0.763 14.405)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3399",
    "data-name": "Ellipse 3399",
    cx: 1.467,
    cy: 1.451,
    rx: 1.467,
    ry: 1.451,
    transform: "translate(41.693 86.745)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3400",
    "data-name": "Ellipse 3400",
    cx: 0.734,
    cy: 0.725,
    rx: 0.734,
    ry: 0.725,
    transform: "translate(27.708 84.958)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3401",
    "data-name": "Ellipse 3401",
    cx: 0.734,
    cy: 0.725,
    rx: 0.734,
    ry: 0.725,
    transform: "translate(0.763 71.816)",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_26",
    transform: "translate(7.176 22.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60581",
    "data-name": "Group 60581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54382",
    "data-name": "Path 54382",
    d: "M39.062,80.4H14.352V51.064l.537-2.09,1.007-.848c4.305.122,7.726.16,10.063.172a97.1,97.1,0,0,1,10.178.4c1,.1,1.831.2,2.389.273l.537,2.09Q39.062,65.731,39.062,80.4Z",
    transform: "translate(-14.352 -46.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60580",
    "data-name": "Group 60580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27_00000116210322056767368760000012981565223886768053_",
    d: "M14.352,98.565v6.919c0,3.347,7.766,4.236,12.355,4.236s12.355-.89,12.355-4.236v-6.9c-2.725,1.454-7.653,2.146-12.355,2.146S17.06,100.034,14.352,98.565Zm5.843,7.052a2.014,2.014,0,1,1,2.012-2.015v0a2.015,2.015,0,0,1-2.015,2.012Z",
    transform: "translate(-14.352 -71.37)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28_00000106838787073453792310000011092853695308407680_",
    d: "M39.062,47c-1.836-2.189-7.95-2.824-11.819-2.824S17.261,44.809,15.425,47c1.37.89,5.422,2.118,11.819,2.118S37.679,47.9,39.062,47Z",
    transform: "translate(-14.888 -44.174)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29_00000089563601272589209280000004705519866325920137_",
    d: "M14.352,54v8.43h.014c0,.791,4.321,2.711,12.341,2.711s12.355-1.92,12.355-2.711V54c-2.725,1.454-7.653,2.146-12.355,2.146S17.06,55.456,14.352,54Zm5.843,8.263a2.012,2.012,0,1,1,2.012-2.012,2.012,2.012,0,0,1-2.012,2.012h0Z",
    transform: "translate(-14.352 -49.088)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29_00000074444152860984082180000004069485778134940578_",
    d: "M14.352,76.284v8.43h.014c0,.791,4.321,2.711,12.341,2.711s12.355-1.92,12.355-2.711v-8.43c-2.725,1.454-7.653,2.146-12.355,2.146S17.06,77.738,14.352,76.284Zm5.843,8.263a2.012,2.012,0,1,1,2.012-2.012,2.012,2.012,0,0,1-2.012,2.012h0Z",
    transform: "translate(-14.352 -60.229)",
    fill: "#d3d3d3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_19",
    transform: "translate(21.356 25.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54383",
    "data-name": "Path 54383",
    d: "M96.721,88.684H50.451a3.2,3.2,0,0,1-3.2-3.2V55.875a3.2,3.2,0,0,1,3.2-3.2H96.721a3.2,3.2,0,0,1,3.2,3.2V85.484A3.2,3.2,0,0,1,96.721,88.684Z",
    transform: "translate(-44.982 -51.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54383_-_Outline",
    "data-name": "Path 54383 - Outline",
    d: "M95.633,88.684H49.364A4.292,4.292,0,0,1,45.076,84.4V54.787A4.293,4.293,0,0,1,49.364,50.5H95.633a4.293,4.293,0,0,1,4.288,4.288V84.4A4.292,4.292,0,0,1,95.633,88.684ZM49.364,52.675a2.114,2.114,0,0,0-2.112,2.112V84.4a2.114,2.114,0,0,0,2.112,2.112H95.633A2.114,2.114,0,0,0,97.745,84.4V54.787a2.114,2.114,0,0,0-2.112-2.112Z",
    transform: "translate(-43.894 -50.5)",
    fill: "#a6a5a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15055",
    "data-name": "Rectangle 15055",
    width: 1.996,
    height: 4.091,
    transform: "translate(27.606 37.096)",
    fill: "#a6a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54384",
    "data-name": "Path 54384",
    d: "M99.921,133.941H79.809a2.909,2.909,0,0,1,2.909-2.909H97.011a2.909,2.909,0,0,1,2.909,2.909Z",
    transform: "translate(-61.26 -90.766)",
    fill: "#a6a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54385",
    "data-name": "Path 54385",
    d: "M78.238,50.53,42.712,86.056l4.375,4.375,39.9-39.9Z",
    transform: "translate(-42.712 -50.515)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54386",
    "data-name": "Path 54386",
    d: "M116.312,59.49,77.792,98.01l1.944,1.944,36.576-36.576Z",
    transform: "translate(-60.252 -54.995)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54387",
    "data-name": "Path 54387",
    d: "M106.986,50.53H104.9L65.84,89.592l2,2,40.483-40.483-.095-.095Z",
    transform: "translate(-54.276 -50.515)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54388",
    "data-name": "Path 54388",
    d: "M106.5,73.92H78.419A.723.723,0,0,1,77.7,73.2V71.928a.723.723,0,0,1,.723-.723H106.5a.723.723,0,0,1,.723.723V73.2A.723.723,0,0,1,106.5,73.92Z",
    transform: "translate(-60.204 -60.852)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54389",
    "data-name": "Path 54389",
    d: "M88.046,67.472H78.419a.723.723,0,0,1-.723-.723v-.478a.723.723,0,0,1,.723-.723h9.627a.723.723,0,0,1,.723.723v.478A.723.723,0,0,1,88.046,67.472Z",
    transform: "translate(-60.204 -58.024)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3402",
    "data-name": "Ellipse 3402",
    cx: 2.632,
    cy: 2.602,
    rx: 2.632,
    ry: 2.602,
    transform: "translate(8.193 7.666)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54390",
    "data-name": "Path 54390",
    d: "M106.5,91.342H78.419a.723.723,0,0,1-.723-.723V89.35a.723.723,0,0,1,.723-.723H106.5a.723.723,0,0,1,.723.723V90.62A.723.723,0,0,1,106.5,91.342Z",
    transform: "translate(-60.204 -69.563)",
    fill: "#f2f1ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54391",
    "data-name": "Path 54391",
    d: "M88.046,84.894H78.419a.723.723,0,0,1-.723-.723v-.478a.723.723,0,0,1,.723-.723h9.627a.723.723,0,0,1,.723.723v.478A.723.723,0,0,1,88.046,84.894Z",
    transform: "translate(-60.204 -66.735)",
    fill: "#f2f1ef"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3403",
    "data-name": "Ellipse 3403",
    cx: 2.632,
    cy: 2.602,
    rx: 2.632,
    ry: 2.602,
    transform: "translate(8.193 16.377)",
    fill: "#f2f1ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54392",
    "data-name": "Path 54392",
    d: "M106.5,109.1H78.419a.723.723,0,0,1-.723-.723v-1.269a.723.723,0,0,1,.723-.723H106.5a.723.723,0,0,1,.723.723v1.269A.723.723,0,0,1,106.5,109.1Z",
    transform: "translate(-60.204 -78.444)",
    fill: "#f2f1ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54393",
    "data-name": "Path 54393",
    d: "M88.046,102.655H78.419a.723.723,0,0,1-.723-.723v-.478a.723.723,0,0,1,.723-.723h9.627a.723.723,0,0,1,.723.723v.478A.723.723,0,0,1,88.046,102.655Z",
    transform: "translate(-60.204 -75.616)",
    fill: "#f2f1ef"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3404",
    "data-name": "Ellipse 3404",
    cx: 2.632,
    cy: 2.602,
    rx: 2.632,
    ry: 2.602,
    transform: "translate(8.193 25.258)",
    fill: "#f2f1ef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_26-2",
    "data-name": "Layer_26",
    transform: "translate(85 236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60480",
    "data-name": "Group 60480",
    transform: "translate(126.63 97.352)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3265",
    "data-name": "Ellipse 3265",
    cx: 12.377,
    cy: 12.377,
    r: 12.377,
    transform: "translate(0)",
    fill: "#f7f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3266",
    "data-name": "Ellipse 3266",
    cx: 9.561,
    cy: 9.561,
    r: 9.561,
    transform: "translate(2.815 2.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54210",
    "data-name": "Path 54210",
    d: "M156.969,133.328h-9.855a.842.842,0,1,1,0-1.684h9.855a.842.842,0,1,1,0,1.684Z",
    transform: "translate(-139.665 -120.109)",
    fill: "#959494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54211",
    "data-name": "Path 54211",
    d: "M161.763,128.534a.842.842,0,0,1-.842-.842v-9.855a.842.842,0,0,1,1.684,0v9.855A.842.842,0,0,1,161.763,128.534Z",
    transform: "translate(-149.387 -110.387)",
    fill: "#959494"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup73477);
export default __webpack_public_path__ + "static/media/Group 73477.2d78b748281fc363bd9c815019fd4ac4.svg";
export { ForwardRef as ReactComponent };